import React from 'react';
import '../App.css';
import StoreLocator from './StoreLocator';

function App() {
  return (
    <div className="App">
      <StoreLocator />
    </div>
  );
}

export default App;
